import type { SupportTranslations } from './types'

export const enTranslations: SupportTranslations = {
  title: 'Support Tickets',
  subtitle: 'Manage customer and internal support requests',
  newTicket: 'New Ticket',
  createForbidden: "You don't have permission to create support tickets. Ask your admin to add the permission.",
  getHelp: 'Get Help',
  submitTicket: 'Submit a Ticket',
  submit: 'Submit Ticket',

  statusOpen: 'Open',
  statusInProgress: 'In Progress',
  statusWaiting: 'Waiting on Reporter',
  statusResolved: 'Resolved',
  statusClosed: 'Closed',

  priorityLow: 'Low',
  priorityMedium: 'Medium',
  priorityHigh: 'High',
  priorityUrgent: 'Urgent',

  channelCustomer: 'Customer',
  channelInternal: 'Internal',
  allChannels: 'All Channels',
  filterChannel: 'Channel',

  categoryOrder: 'Order Issue',
  categoryDelivery: 'Delivery Issue',
  categoryPayment: 'Payment Issue',
  categoryAccount: 'Account Issue',
  categoryBug: 'Platform Bug',
  categoryHardware: 'Malfunctioning Hardware',
  categoryFeature: 'Feature Request',
  categoryGeneral: 'General',
  categoryOther: 'Other',

  statsOpen: 'Open',
  statsInProgress: 'In Progress',
  statsResolved: 'Resolved',
  statsTotal: 'Total',

  colTicket: 'Ticket #',
  colSubject: 'Subject',
  colChannel: 'Channel',
  colCategory: 'Category',
  colPriority: 'Priority',
  colStatus: 'Status',
  colCreated: 'Created',
  colSla: 'SLA',
  slaMet: 'SLA Met',
  slaBreached: 'SLA Breached',
  slaOutcome: 'SLA Outcome',
  slaSelect: 'Was the SLA met?',
  slaOpenFor: 'Open for',
  slaTarget: 'Target',
  slaDue: 'Due',
  slaSuggestMet: 'Within the target — suggested: SLA Met',
  slaSuggestBreached: 'Past the target — suggested: SLA Breached',

  fieldFactory: 'Plant',
  selectFactory: 'Select plant',
  fieldSubject: 'Subject',
  fieldCategory: 'Category',
  fieldPriority: 'Priority',
  fieldDescription: 'Description',
  fieldEmail: 'Contact Email',
  fieldPhone: 'Contact Phone',
  fieldAttachments: 'Photos',
  subjectPlaceholder: 'Brief summary of your issue',
  selectCategory: 'Select category',
  descriptionPlaceholder: 'Describe your issue in detail...',
  emailPlaceholder: 'email@example.com',
  phonePlaceholder: '+966 5X XXX XXXX',
  attachmentsHint: 'Upload up to 5 photos (max 10MB each)',
  attachmentsRequired: 'At least one photo is required',
  removePhoto: 'Remove photo',
  addPhoto: 'Click to add photos',
  addPhotoFormats: 'JPG, PNG, WEBP, GIF',
  fileTooLarge: 'Files must be under 10MB',
  photo: 'photo',
  photos: 'photos',
  submittingAs: 'Submitting as',
  submitting: 'Submitting...',

  searchPlaceholder: 'Search tickets...',
  filterByStatus: 'Filter by Status',
  selectStatus: 'Select status',
  noTickets: 'No support tickets found',

  tabOverview: 'Overview',
  tabNotes: 'Notes',
  tabTimeline: 'Timeline',
  timelineCreated: 'Ticket opened',
  timelineNoteAdded: 'Note added',
  noTimeline: 'No activity yet',
  none: 'none',
  value: {
    open: 'Open',
    in_progress: 'In Progress',
    waiting_on_reporter: 'Waiting on Reporter',
    resolved: 'Resolved',
    closed: 'Closed',
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    urgent: 'Urgent',
    met: 'SLA Met',
    breached: 'SLA Breached',
    order_issue: 'Order Issue',
    delivery_issue: 'Delivery Issue',
    payment_issue: 'Payment Issue',
    account_issue: 'Account Issue',
    platform_bug: 'Platform Bug',
    malfunctioning_hardware: 'Malfunctioning Hardware',
    feature_request: 'Feature Request',
    general: 'General',
    other: 'Other',
    customer_to_spcc: 'Customer',
    spcc_to_525k: 'Internal',
    customer_portal: 'Customer Portal',
    ecommerce_app: 'Ecommerce App',
    admin_portal: 'Admin Portal',
    gate_portal: 'Gate Portal',
    kiosk_portal: 'Kiosk Portal',
  },
  assignedTo: 'Assigned To',
  unassigned: 'Unassigned',
  tenant: 'Tenant',
  resolvedAt: 'Resolved At',
  updateStatus: 'Update Status',

  noNotes: 'No notes yet',
  addNote: 'Add Note',
  notePlaceholder: 'Add a note...',

  exportReport: 'Export Report',
  exportPreparing: 'Preparing report...',
  exportSuccess: 'Report downloaded',
  exportError: 'Could not generate the report',
  exportEmpty: 'No tickets match the current filters',
  exportTruncated: 'Report capped — narrow the filters for a complete report',
  reportSheetSummary: 'Summary',
  reportSheetTickets: 'Tickets',
  reportColMetric: 'Metric',
  reportColValue: 'Value',
  reportColPercent: '%',
  reportGeneratedAt: 'Generated at',
  reportFiltersApplied: 'Filters applied',
  reportFiltersNone: 'None — all tickets',
  reportTotalTickets: 'Total tickets',
  reportBreachRate: 'SLA breach rate',
  reportAvgResolutionHours: 'Avg resolution (h)',
  reportMedianResolutionHours: 'Median resolution (h)',
  reportByStatus: 'By Status',
  reportByPriority: 'By Priority',
  reportByCategory: 'By Category',
  reportByChannel: 'By Channel',
  colDescription: 'Description',
  colSourcePortal: 'Source Portal',
  colResolutionHours: 'Resolution (h)',
  colSlaTarget: 'SLA Target (h)',
  colOverdue: 'Overdue',
  colNotes: 'Notes',
  yes: 'Yes',
  no: 'No',

  createSuccess: 'Support ticket created successfully',
  updateSuccess: 'Support ticket updated successfully',
  createError: 'Failed to create support ticket',
  updating: 'Updating...',
  customerSupportTitle: 'Support',
  customerSupportSubtitle: 'Get help with your orders, deliveries, and account',
  myTickets: 'My Tickets',
  noMyTickets: 'You have no support tickets yet',
}
